<template>
  <div
    class="popover-page-render-wrap"
    :style="{
      width: `${width}px`,
      borderRadius: `${borderRadius}px`,
      backgroundColor: backgroundColor || '#ffffff',
      overflow: 'hidden',
    }"
  >
    <EmbeddedLowCodePageRender
      :area-data="areaData"
      :is-mobile="true"
      :empty-text="ct('暂无浮框内容')"
    />
  </div>
</template>

<script setup>
const ct = useCommonUiTranslation()

import EmbeddedLowCodePageRender from "@/components/render/EmbeddedLowCodePageRender.vue";

const props = defineProps({
  areaData: {
    type: String,
    default: "",
  },
  width: {
    type: Number,
    default: 400,
  },
  backgroundColor: {
    type: String,
    default: "",
  },
  borderRadius: {
    type: Number,
    default: 6,
  },
});

</script>

<style scoped>
.popover-page-render-wrap {
  max-width: 100%;
  overflow: auto;
  max-height: 80vh;
}

</style>
